export const NAMESPACE = 'image-injection';

export const IMAGE_INJECTION_MAX_FILE_SIZE = 5242880; // 5MB
